"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _part = _interopRequireDefault(require("../utils/part"));

var inToQuery = function inToQuery(fieldName, values) {
  return (0, _part.default)(fieldName, {
    $in: Array.isArray(values) ? values : [values]
  });
};

var _default = inToQuery;
exports.default = _default;